import React from "react";
import { useParams } from "react-router-dom";

import blogs from "./data";
import "./BlogDetails.css";

const BlogDetails = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return <h2 style={{ textAlign: "center" }}>Blog Not Found</h2>;
  }

  return (
    <>

      <div className="blog-details">
        <img src={blog.image} alt={blog.title} />

        <div className="details-content">
          <h1 >{blog.title}</h1>
          <span className="date">{blog.date}</span>

          <div
            className="blog-text"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
